import type { ConfigType } from "@plone/registry";
import { widgetMapping } from './Widgets';

export default function install(config: ConfigType) {
  config.widgets = {
    ...config.widgets,
    widget: {
      ...config.widgets.widget,
      ...widgetMapping.widget,
    },
    views: {
      ...config.widgets.views,
      widget: {
        ...config.widgets.views.widget,
        //...widgetMapping.views.widget,
      },
    },
  };
  
  return config;
}
